import { useEffect, useState } from 'react';
import { useReception } from '../../../_utils/receptionMode';

/**
 * What the "Continue setting up" pill would say right now, for screens that
 * show it their own way instead of floating the pill over themselves (the
 * Bailey tab, where the pill sat on top of the message box).
 *
 * SetupHost publishes; anyone can read. null when there is no pill.
 * { kind: 'setup' | 'held', title, detail, done, total, go, open() }
 */
let current = null;
const listeners = new Set();

export function publishPill(pill) {
  current = pill;
  listeners.forEach((fn) => fn(pill));
}

export function useSetupPill() {
  const [pill, setPill] = useState(current);
  useEffect(() => {
    listeners.add(setPill);
    setPill(current);
    return () => { listeners.delete(setPill); };
  }, []);
  // Setup is never on a locked front-desk device.
  const { setupOff } = useReception();
  return setupOff ? null : pill;
}
